import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CellColors } from '@ddv/models';

@Component({
    selector: 'ddv-cell-and-font-color',
    templateUrl: './cell-and-font-color.component.html',
    styleUrls: ['./cell-and-font-color.component.scss'],
})
export class CellAndFontColorComponent {
    @Input() cellValue: string | undefined;
    @Input() fontValue: string | undefined;
    @Input() cellAndFontColors: CellColors[] = [];
    @Output() colorSelected = new EventEmitter<CellColors>();

    protected cellKey = 'cellColor';
    protected fontKey = 'fontColor';

    onCellFontColorSelected(item: CellColors, el: HTMLDivElement): void {
        el.hidden = true;
        this.colorSelected.emit(item);
    }
}
